// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelStep-SectionGrid_cls1__D9JY3","cls2":"PaymentChannelStep-SectionGrid_cls2__eFxaR PaymentChannelStep-SectionGrid_cls1__D9JY3"};